import React from "react";

export const shippedCounts = (order) => {
  const items = order.items || [];
  const total = items.reduce((s, it) => s + Number(it.quantity || 0), 0);
  const shipped = items.reduce((s, it) => s + Number(it.shipped_qty || 0), 0);
  return { total, shipped, remaining: total - shipped };
};

/** Righe articolo con stato spediti/rimanenti + elenco spedizioni (tracking) dell'ordine. */
export const OrderItemsList = ({ order, formatPrice }) => {
  const items = order.items || [];
  const partial = order.status === "partially_shipped";
  const { total, shipped } = shippedCounts(order);
  return (
    <div className="mb-4" data-testid={`order-items-${order.id}`}>
      <div className="flex items-center gap-2 mb-2">
        <h4 className="font-medium text-gray-900">Prodotti Ordinati</h4>
        {partial && (
          <span className="text-xs font-bold bg-orange-100 text-orange-700 border border-orange-300 px-2 py-0.5 rounded-full" data-testid={`order-partial-badge-${order.id}`}>
            📦 {shipped}/{total} pezzi spediti
          </span>
        )}
      </div>
      <div className="space-y-2">
        {items.length === 0 && <p className="text-gray-500 text-sm">Nessun prodotto disponibile</p>}
        {items.map((item, index) => {
          const qty = Number(item.quantity || 0);
          const sq = Number(item.shipped_qty || 0);
          const rem = qty - sq;
          const price = item.price ?? item.article?.price;
          return (
            <div key={`order-item-${index}-${item.article_id || "x"}`} className="flex justify-between items-center py-2 border-b border-gray-100" data-testid={`order-item-row-${order.id}-${index}`}>
              <div>
                <span className="font-medium">{item.title || item.article?.title || item.article_id || "Prodotto non disponibile"}</span>
                <span className="text-gray-600 ml-2">x{qty}</span>
                {item.availability_type === "preorder" && <span className="ml-2 text-[10px] font-bold text-purple-700 bg-purple-100 px-1.5 py-0.5 rounded">PREVENDITA</span>}
                {(partial || sq > 0) && (
                  <span className={`ml-2 text-xs font-semibold ${rem === 0 ? "text-green-700" : sq > 0 ? "text-orange-700" : "text-gray-500"}`} data-testid={`order-item-shipstate-${order.id}-${index}`}>
                    {rem === 0 ? "✅ spedito" : sq > 0 ? `✅ ${sq} spediti · ⏳ ${rem} da spedire` : "⏳ da spedire"}
                  </span>
                )}
              </div>
              <span className="font-medium">{price ? formatPrice(price * qty) : "N/A"}</span>
            </div>
          );
        })}
      </div>
      {(order.shipments || []).length > 0 && (
        <div className="mt-2 text-xs text-gray-700 space-y-1" data-testid={`order-shipments-${order.id}`}>
          {order.shipments.map((s, i) => (
            <p key={s.id || i}>
              📦 Spedizione {i + 1} · {new Date(s.date).toLocaleDateString("it-IT")} · tracking <span className="font-mono">{s.tracking_number}</span>
              {s.carrier ? ` (${s.carrier})` : ""} · {(s.items || []).map((it) => `${it.quantity}× ${it.title}`).join(", ")}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};
